import { UserAgentApplication } from 'msal';

const getConfig = () => {
	let obj = {}
}

const { REACT_APP_MS_APP_ID, REACT_APP_MS_REDIRECT_URL, REACT_APP_MS_AUTHORITY } = process.env;

export const publicClientApp = new UserAgentApplication({


	auth: {
		clientId: process.env.REACT_APP_MS_CLIENT_ID || '',
		redirectUri: "https://www.pmrvira.com",
		authority: process.env.REACT_APP_MS_AUTHORITY_URL,
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false,
	},
});
